import {BlueshiftIcon} from "../../components/icon/BlueshiftIcon.tsx";
import type {Flavor} from "../../lib/ModelTypes.ts";
import React from "react";
import {replaceName} from "../../util/ReplaceText.tsx";


type FlavorListProps = {
    data: Flavor[]
};

export const FlavorList = React.memo(({data}: FlavorListProps) => {
    return (
        <>
            {data.map((flavor) => {
                const elements: JSX.Element[] = [];
                if (flavor.quota <= 0) {
                    return;
                }

                for (let index = 0; index < flavor.quota; index++) {
                    elements.push(
                        <div key={flavor.name + "_" + index} className="col-3" style={{color: flavor.usage > index ? "#264EDD" : "#585757"}}>
                            <BlueshiftIcon.FlavorIcon/>
                            <h5 className="my-3">{replaceName(flavor.name)}</h5>
                        </div>
                    );
                }

                return elements;
            })}
        </>
    );
})

// export default FlavorList;